import React from 'react';
import { Row, Col } from 'antd';
import pageS from '../../s.module.less';
import s from './s.module.less';
import Setup1 from 'assets/payment/setup-1.png';
import Setup2 from 'assets/payment/setup-2.png';
import Setup3 from 'assets/payment/setup-3.png';
import Setup4 from 'assets/payment/setup-4.png';

const IntroStep = () => {
    return (
        <div className={s.introStep}>
            <div className={s.header}>
                <h1 className={pageS.stepTitle}>Set up your provider payment hub in minutes</h1>
                <p className={pageS.desc}>Why set-up your payment account to receive patient payment?</p>
            </div>

            <Row gutter={[40, 40]} className={s.featureCards}>
                <Col xs={24} md={12}>
                    <div className={s.card}>
                        <div className={s.cardImage}>
                            <img src={Setup1} alt="Prevent no-shows & late cancellations" />
                        </div>
                        <div>
                            <h3 className={pageS.title}>Prevent no-shows & late cancellations </h3>
                            <p className={pageS.desc}>By collecting patient payment information during intake, patients honor their commitments. You’ll reclaim your schedule to serve those who truly need your care.</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} md={12}>
                    <div className={s.card}>
                        <div className={s.cardImage}>
                            <img src={Setup2} alt="Honor the healing journey" />
                        </div>
                        <div>
                            <h3 className={pageS.title}>Honor the healing journey</h3>
                            <p className={pageS.desc}>Keep therapeutic moments sacred by moving payment conversations out of the treatment room. Patients complete transactions privately before or after their visit.</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} md={12}>
                    <div className={s.card}>
                        <div className={s.cardImage}>
                            <img src={Setup3} alt="Meet patients where they are" />
                        </div>
                        <div>
                            <h3 className={pageS.title}>Meet patients where they are</h3>
                            <p className={pageS.desc}>Accommodate diverse financial situations with flexible options: credit/debit cards, HSA/FSA accounts, Apple/Google Pay, multiple installment plans.</p>
                        </div>
                    </div>
                </Col>

                <Col xs={24} md={12}>
                    <div className={s.card}>
                        <div className={s.cardImage}>
                            <img src={Setup4} alt="Expand your revenue streams" />
                        </div>
                        <div>
                            <h3 className={pageS.title}>Expand your revenue stream</h3>
                            <p className={pageS.desc}>Seamlessly manage every financial aspect of care. You could leverage Kiwi Pay to collect no-show penalties, copays, memberships, wellness products, and medication dispensing—all from one secured payment gateway.</p>
                        </div>
                    </div>
                </Col>
            </Row>

        </div>
    );
};

export default IntroStep;
